module.exports = __webpack_public_path__ + "static/img/baselineRepair_pic08.982db5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/baselineRepair/baselineRepair_pic08.png
// module id = 473
// module chunks = 1